import { render, staticRenderFns } from "./MarkAllAsRead.vue?vue&type=template&id=b3f1fd30"
import script from "./MarkAllAsRead.vue?vue&type=script&lang=ts"
export * from "./MarkAllAsRead.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3f1fd30')) {
      api.createRecord('b3f1fd30', component.options)
    } else {
      api.reload('b3f1fd30', component.options)
    }
    module.hot.accept("./MarkAllAsRead.vue?vue&type=template&id=b3f1fd30", function () {
      api.rerender('b3f1fd30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notification/MarkAllAsRead.vue"
export default component.exports